import { ClockFormat } from '@graphql/generated-base';

/**
 * Maps an event's stored clock preference onto `Intl.DateTimeFormat`'s `hour12`.
 *
 * `undefined` leaves the decision to the locale, which is what every event does without a stored
 * preference: 'es-ES' renders 15:30 while 'en-US' renders 3:30 PM. Couples whose language defaults
 * to a clock they don't use set the preference explicitly instead.
 */
export const resolveHour12 = (clockFormat?: ClockFormat | null): boolean | undefined => {
  switch (clockFormat) {
    case ClockFormat.twelveHour:
      return true;
    case ClockFormat.twentyFourHour:
      return false;
    default:
      return undefined;
  }
};
